import { RESOURCE_TYPE } from 'constants/common';

export const ResourceTypesProperty: {[key: string]: string} = {
    [RESOURCE_TYPE.CHECKLIST]: 'Checklist'
}

export default {
    OPEN_RESOURCE: 'Open resource'
}
